import { Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../theme";
import ActivityLogTableNewUI from "./ActivityLogTableNewUI";

interface PropType {
  closeDrawer: Function;
  memberEmail : string;
}
const ActivityLogDrawerNew = (props: PropType) => {
  const { closeDrawer ,memberEmail } = props;
  return (
    <Grid>
      <Grid
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={5}
        py={3}
        sx={{
          position: "sticky",
          top: 0,
          background: theme.color?.background,
        }}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Activity Log
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={() => {
            closeDrawer(false);
          }}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid width={"100%"} p={2} px={4}>
        <ActivityLogTableNewUI memberEmail={memberEmail}></ActivityLogTableNewUI>
      </Grid>
    </Grid>
  );
};

export default ActivityLogDrawerNew;
